import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/States";
import VerifyEmail from "@/pages/VerifyEmail";

export default function ProtectedRoute({ children, adminOnly = false, employerOnly = false }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading label="Checking your session..." full />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  if (user.email_verified === false) return <VerifyEmail />;
  if (employerOnly !== (user.role === "employer")) return <Navigate to={user.role === "employer" ? "/employer" : "/dashboard"} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
